import LogRocket from 'logrocket';

LogRocket.init('tv5tgr/uselenoxcom');
if (localStorage.getItem('email')) {
  LogRocket.identify(localStorage.getItem('email'));
}
